export default __webpack_public_path__ + "static/media/illustration.75c18d34.svg";